import type { DriverEntity } from '@/features/driver/domain/entities/DriverEntity'
import type { DriverTeamChannelEntity } from './DriverTeamChannelEntity'

export class DriverTeamEntity {
  id?: number
  name?: string | null
  drivers?: Array<DriverEntity> | null
  channels?: Array<DriverTeamChannelEntity> | null
}
